import {Drawer, useMediaQuery} from "@mui/material";
import React from "react";
import SidebarMenuList from "../../includes/sidebarMenuList";
import {isDesktop, drawerWidth} from "../constants";
import json2mq from "json2mq";
import {getAlertCountAPI} from "../../apihelper/profile";
import IconButton from "@mui/material/IconButton";
import {useNavigate} from "react-router-dom";

const Header3 = ({index, children}) => {
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const mediaQueryVar = useMediaQuery(json2mq(isDesktop));
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const [unreadAlerts, setUnreadAlerts] = React.useState(0);

    React.useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlerts = async () => {
            const response = await getAlertCountAPI(userData?.user_id);
            if (response?.unread_notifications) {
                setUnreadAlerts(response?.unread_notifications);
            }
        };

        fetchAlerts();
    }, []);

    return mediaQueryVar ? (
        <div className="col" style={{maxWidth: "315px"}}>
            <Drawer
                variant="permanent"
                open
                sx={{
                    display: {xs: "block"},
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: drawerWidth,
                        backgroundColor: "white",
                        color: "#727376",
                    },
                }}
            >
                <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
                    <SidebarMenuList />
                </div>
            </Drawer>
        </div>
    ) : (
        <div>
            <div className="d-flex justify-content-between px-1 py-4">
                <>
                    <div className=" my-profile-container">
                        <a
                            href="/account"
                            className="rounded-pill px-3 py-2 d-flex align-items-center justify-content-between my-profile-btn w-auto"
                        >
                            <img src="images/profile_image/account_image/profile-icon.svg" />

                            <span className="tab-text">My Profile</span>
                        </a>
                    </div>

                    <div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between", // Changed from space-between to flex-end
                                marginTop: "0px",
                                marginLeft: "0px",
                                fontSize: "20px",
                            }}
                        >
                            <div style={{display: "flex", alignItems: "center"}}>
                                <a className="notification-section position-relative" href={"/alerts"}>
                                    <img
                                        src="images/profile_image/account_image/notification-icon.svg"
                                        className="notification-icon fa-2x"
                                    />
                                    {unreadAlerts > 0 && (
                                        <span className="badge rounded-pill badge-notification bg-danger position-absolute top-0 start-100 ">
                                            {unreadAlerts}
                                        </span>
                                    )}
                                </a>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="end"
                                    onClick={handleDrawerToggle}
                                >
                                    <img
                                        src="/images/menubar.svg"
                                        alt="Menu Icon"
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            marginRight: "10px",
                                            marginTop: "0px",
                                        }}
                                    />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </>
            </div>
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{keepMounted: true}}
                sx={{
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: drawerWidth,
                        backgroundColor: "white",
                        color: "#727376",
                    },
                }}
            >
                <SidebarMenuList />
            </Drawer>
        </div>
    );
};

export default Header3;
